export enum CONSTANTS {
  EXIT = 'EXIT'
}
